export type { GetOrderTimeProps } from './getOrderTime';
export { getOrderTime } from './getOrderTime';
